import { PhoneCountryCode, PaginationParams } from '../../../../types';
import { DefineRequest } from '../../types';
import { core } from '../../apis';
import { buildPaginationParams, unknownBy } from '../../helpers';

interface OptionsByUnscoped extends PaginationParams {
  by: 'unscoped';
}

export type GetPhoneCountryCodes = DefineRequest<
  OptionsByUnscoped,
  PhoneCountryCode[]
> & {
  optionsByUnscoped: OptionsByUnscoped;
};

export const getPhoneCountryCodes: GetPhoneCountryCodes['request'] = (
  options
) => {
  const path = buildPath(options);
  return core
    .get<{ codes: GetPhoneCountryCodes['response'] }>(
      { accessToken: true },
      path,
      {
        queryParams: buildPaginationParams(options),
      }
    )
    .then((response) => response.codes);
};

const buildPath = (options: GetPhoneCountryCodes['options']) => {
  switch (options.by) {
    case 'unscoped': {
      return '/phone_country_codes';
    }

    default: {
      throw unknownBy(options.by);
    }
  }
};
